import { useId } from 'react'

export function TopicIconSmall({ className }: { className?: string }) {
  const gradId = useId()

  return (
    <svg
      width="17"
      height="17"
      viewBox="6 4 84 72"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="96" y2="80">
          <stop offset="0%" stopColor="#3A9BA8" />
          <stop offset="100%" stopColor="#51B0BC" />
        </linearGradient>
      </defs>
      <rect
        x="10"
        y="8"
        width="76"
        height="64"
        rx="12"
        className="fill-card stroke-border"
      />
      <rect
        x="24"
        y="22"
        width="48"
        height="8"
        rx="4"
        fill={`url(#${gradId})`}
      />
      <rect
        x="24"
        y="36"
        width="36"
        height="8"
        rx="4"
        className="fill-muted-foreground/30"
      />
      <rect
        x="24"
        y="50"
        width="42"
        height="8"
        rx="4"
        className="fill-muted-foreground/30"
      />
      <rect
        x="16"
        y="22"
        width="4"
        height="8"
        rx="2"
        fill={`url(#${gradId})`}
      />
      <path
        d="M58 30 L76 44 L58 58"
        stroke="#FFE739"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}
